import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-disable react/sort-comp */
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as PropTypes from 'prop-types';
import { polyfill } from 'react-lifecycles-compat';
import classnames from 'classnames';
import { getCloserScrollElement } from './util';
var DEFAULTPOS = '0';
var plcasementClass = ['bottom-left', 'bottom-right', 'top-left', 'top-right', 'bottom', 'top'];

var Popup = /*#__PURE__*/function (_React$Component) {
  _inherits(Popup, _React$Component);

  var _super = _createSuper(Popup);

  function Popup() {
    var _this;

    _classCallCheck(this, Popup);

    _this = _super.apply(this, arguments);
    _this.state = {
      target: ''
    };
    _this.rootDOM = null;
    _this.targetDOM = null;
    _this.verhicalScrollContainer = null;
    _this.horizontalScrollContainer = null;

    _this.getTargetDOM = function () {
      var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props.target;

      if (!target) {
        _this.targetDOM = null;
        return;
      }

      if (target instanceof Element) {
        _this.targetDOM = target;
        return;
      }

      if (typeof target === 'string') {
        _this.targetDOM = document.querySelector(target);
      }
    };

    _this.updatePosition = function () {
      if (!_this.rootDOM || !_this.props.isShow) {
        return;
      }

      var _this$clacPosition = _this.clacPosition(),
          top = _this$clacPosition.top,
          left = _this$clacPosition.left;

      _this.rootDOM.setAttribute('style', "top: ".concat(top, "; left: ").concat(left, "; ").concat(_this.props.width ? "width: ".concat(_this.props.width) : ''));
    };

    return _this;
  }

  _createClass(Popup, [{
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate() {
      this.getTargetDOM();
      return null;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.targetDOM || !this.props.updatePlacementOnScroll) {
        return;
      }

      window.addEventListener('resize', this.updatePosition);

      if (!this.verhicalScrollContainer && this.targetDOM) {
        this.verhicalScrollContainer = getCloserScrollElement(this.targetDOM);
        this.horizontalScrollContainer = getCloserScrollElement(this.targetDOM, 'horizontal');
      }

      if (this.verhicalScrollContainer) {
        this.verhicalScrollContainer.addEventListener('scroll', this.updatePosition);
      }

      if (this.horizontalScrollContainer) {
        this.horizontalScrollContainer.addEventListener('scroll', this.updatePosition);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.getTargetDOM(this.state.target);
      this.updatePosition();

      if (!this.verhicalScrollContainer && this.targetDOM) {
        this.verhicalScrollContainer = getCloserScrollElement(this.targetDOM);
        this.horizontalScrollContainer = getCloserScrollElement(this.targetDOM, 'horizontal');
      }

      if (this.verhicalScrollContainer) {
        this.verhicalScrollContainer.addEventListener('scroll', this.updatePosition);
      }

      if (this.horizontalScrollContainer) {
        this.horizontalScrollContainer.addEventListener('scroll', this.updatePosition);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.updatePosition);

      if (this.verhicalScrollContainer) {
        this.verhicalScrollContainer.removeEventListener('scroll', this.updatePosition);
      }

      if (this.horizontalScrollContainer) {
        this.horizontalScrollContainer.removeEventListener('scroll', this.updatePosition);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var pos = this.clacPosition();
      return /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement("div", {
        className: classnames('popup', this.props.className, pos.realPlacement),
        style: this.clacStyle(pos),
        onMouseLeave: this.props.onMouseLeave,
        ref: function ref(root) {
          _this2.rootDOM = root;
        }
      }, this.props.children), document.body);
    }
  }, {
    key: "getScrollTop",
    value: function getScrollTop() {
      return (document.scrollingElement || document.documentElement || document.body).scrollTop || document.body.scrollTop;
    }
  }, {
    key: "getScrollLeft",
    value: function getScrollLeft() {
      return (document.scrollingElement || document.documentElement || document.body).scrollLeft || document.body.scrollLeft;
    }
  }, {
    key: "clacPosition",
    value: function clacPosition() {
      var left = DEFAULTPOS;
      var top = DEFAULTPOS;

      var _rp = this.props.placement.replace(/([A-Z])/, function (p1) {
        return "-".concat(p1.toLocaleLowerCase());
      }); // 值的合法性可以保证


      var realPlacement = plcasementClass.indexOf(_rp) === -1 ? 'bottom-left' : _rp;

      if (!this.props.isShow || !this.targetDOM || !this.rootDOM) {
        return {
          top: top,
          left: left,
          realPlacement: realPlacement
        };
      }

      var targetRect = this.targetDOM.getBoundingClientRect();
      var pageScrollTop = this.getScrollTop();
      var pageScrollLeft = this.getScrollLeft();

      switch (this.props.placement) {
        case 'top':
          top = "".concat(targetRect.top + pageScrollTop, "px");
          left = "".concat(targetRect.left + targetRect.width / 2 + pageScrollLeft, "px");
          break;

        case 'bottom':
          top = "".concat(targetRect.top + targetRect.height + pageScrollTop, "px");
          left = "".concat(targetRect.left + targetRect.width / 2 + pageScrollLeft, "px");
          break;

        case 'topLeft':
          top = "".concat(targetRect.top + pageScrollTop, "px");
          left = "".concat(targetRect.left + pageScrollLeft, "px");
          break;

        case 'topRight':
          top = "".concat(targetRect.top + pageScrollTop, "px");
          left = "".concat(targetRect.left + targetRect.width + pageScrollLeft, "px");
          break;

        case 'bottomRight':
          top = "".concat(targetRect.top + targetRect.height + pageScrollTop, "px");
          left = "".concat(targetRect.left + targetRect.width + pageScrollLeft, "px");
          break;

        default:
          top = "".concat(targetRect.top + targetRect.height + pageScrollTop, "px");
          left = "".concat(targetRect.left + pageScrollLeft, "px");
          realPlacement = 'bottom-left';
          break;
      }

      return {
        top: top,
        left: left,
        realPlacement: realPlacement
      };
    }
  }, {
    key: "clacStyle",
    value: function clacStyle(_ref) {
      var top = _ref.top,
          left = _ref.left;
      var obj = {
        top: top,
        left: left
      };

      if (this.props.width && this.props.width !== 'auto') {
        obj.width = this.props.width;
      }

      if (!this.props.isShow) {
        obj.display = 'none';
      }

      return obj;
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, preState) {
      if (nextProps.target !== preState.target) {
        return {
          target: nextProps.target
        };
      }

      return null;
    }
  }]);

  return Popup;
}(React.Component);

Popup.propTypes = {
  placement: PropTypes.oneOf(['bottomLeft', 'bottomRight', 'topLeft', 'topRight', 'bottom', 'top']),
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.objectOf(PropTypes.string), PropTypes.arrayOf(PropTypes.string)]),
  width: PropTypes.string,
  isShow: PropTypes.bool.isRequired,
  onMouseLeave: PropTypes.func,
  target: PropTypes.oneOfType([PropTypes.instanceOf(HTMLElement), PropTypes.string]),
  updatePlacementOnScroll: PropTypes.bool
};
Popup.defaultProps = {
  className: null,
  target: null,
  placement: 'bottomLeft',
  width: 'auto',
  onMouseLeave: function onMouseLeave() {},
  updatePlacementOnScroll: true
};
polyfill(Popup);
export default Popup;